import { createFeatureSelector, createSelector } from '@ngrx/store';
import {AppState, STORE_FEATURE_KEY} from '../../../app.state';
import {categoriesFeature} from '@app/marketplace/categories/state/category/categories-selectors';

export const storesFeature = createFeatureSelector<AppState>(STORE_FEATURE_KEY);
export const selectLoading = createSelector(
  storesFeature,
  (state: AppState) => state.store_details.isLoading
);
export const selectResponse = createSelector(
  storesFeature,
  (state: AppState) => state.store_details.data
);

